"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PageTitle = require("./PageTitle");
Object.keys(_PageTitle).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PageTitle[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PageTitle[key];
    }
  });
});